import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

const theme = createTheme({
  palette: {
    primary: { main: "#3A54AF" },
    secondary: { main: red[800] },
    success: { main: "#86CC7D" },
    wwerror: { main: "#e34e54"},
    wwwarning: { main: "#EEA935"},
    wwsuccess: { main : "#5AA86E"},
    wwprimary: { main : "#3667C6"},
    wwborder: { main : "#aaa"},
    wwfontclr: { main : "#444"},
    wwfontlightclr : { main : "#777"},
    wwholiday: {main: "#a18b0d"},
    wwwhite: {main: "#FFFFFF"}
  },
  typography: {
    fontFamily: ["Montserrat", "sans-serif"].join(","),
  },
});

export default theme;
